import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import {
  Box,
  Button,
  Card,
  Chip,
  IconButton,
  Modal,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import PropTypes from "prop-types";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import NodataImg from "../../assets/images/noData.png";
import { courseApi } from "../../store/courses/coursesList";
import { courseDeleteApi } from "../../store/courses/deleteCourse";
import { manageSplashScreenApi } from "../../store/cms/manageSplashScreen";
import { splashScreenDeleteApi } from "../../store/cms/deleteSplashScreen";
import { channelBannerDeleteApi } from "../../store/channel-banner/deleteChannelBanner";
import { managechannelBannerApi } from "../../store/channel-banner/ManageChannelBanner";

export default function DeleteBanner({ open, setOpen,id,query  }) {


  const deleteSplashScreen = useSelector((state) => state?.deleteSplashScreen);


  const dispatch = useDispatch();
  const navigate = useNavigate();


  const handleClose = () => setOpen(false);

  const deleteCourseConfirm = async () => {
    await dispatch(
      channelBannerDeleteApi(id)
    );
    setOpen(false);
    if (!deleteSplashScreen?.loading) {
      dispatch(
        managechannelBannerApi(query));
      navigate("/channel-banner");
    }
  };

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Card className="modal" sx={{ width: "30%" }}>
          <Stack alignItems="flex-end">
            <IconButton onClick={handleClose}>
              <HighlightOffIcon />
            </IconButton>
          </Stack>
          <Stack alignItems="center" my={2}>
            <Typography variant="h5" fontWeight={600}>
              Are you sure you want to delete this ?
            </Typography>
            <Typography variant="h5" fontWeight={600}>
              Please click confirm
            </Typography>
          </Stack>
          

          <Stack sx={{ mt: 2 }} justifyContent="center" direction="row">
            <Button variant="outlined" onClick={() => setOpen(false)} sx={{ mr: 2 }}>
              Back
            </Button>
            <Stack direction="row" spacing={1}>
              {/* <Button variant='outlined' onClick={notRequiredOrderHandler}>Not Required</Button> */}
              <Button variant="contained" onClick={deleteCourseConfirm}>
                Confirm
              </Button>
            </Stack>
          </Stack>
        </Card>
      </Modal>
    </>
  );
}

DeleteBanner.propTypes = {
  open: PropTypes.any,
  setOpen: PropTypes.any,
  id: PropTypes.any,
  query:PropTypes.any
};
